import { langPath, type Lang } from "@/lib/i18n";
import { safeRedirect } from "@/lib/routes/canonicalize";

/** Explicit navigation wins over the same-browser registration handoff. */
export function authReturn(lang: Lang, explicit?: unknown, saved?: string): string {
  const candidate = explicit == null ? saved : typeof explicit === "string" ? explicit : undefined;
  return safeRedirect(candidate, langPath(lang, "/dashboard"));
}

export function authHref(lang: Lang, page: "/login" | "/register", next: string): string {
  return `${langPath(lang, page)}?redirect=${encodeURIComponent(authReturn(lang, next))}`;
}

export function isAssistantReturn(path: string): boolean {
  return /^\/[A-Z]{2,3}\/asistent(?:\?|$)/.test(path);
}
